import { createRpcClientV2 } from 'rpc-client-utils';
import { listByPathRpc } from '../../__generated__/chirp/com/hubspot/content/themes/modules/rpc/ThemePresetRpc';
import { createRpc, updateBufferRpc, hasBufferedChangesRpc } from '../../__generated__/chirp/com/hubspot/content/themes/modules/rpc/ActiveThemePresetRpc';
import http from 'hub-http/clients/apiClient';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const fetchPresets = themePath => rpcClient.call(listByPathRpc, {
  request: {
    path: themePath
  }
});
export const initializeActivePreset = themePath => rpcClient.call(createRpc, {
  request: {
    themePath,
    activeThemePresetType: 'EMPTY'
  }
});
export const hasBufferedPresetChanges = activeThemePresetObjectId => rpcClient.call(hasBufferedChangesRpc, {
  request: {
    id: activeThemePresetObjectId
  }
});
export const updateActivePresetBuffer = (activeThemePresetObjectId, activeThemePresetType, activeThemePresetId) => {
  return rpcClient.call(updateBufferRpc, {
    request: {
      id: activeThemePresetObjectId,
      activeThemePresetId,
      activeThemePresetType
    }
  });
};